<ion-header>
  <ion-toolbar>
    <ion-back-button [color]="'dark'" slot="start" defaultHref="/home" text="" icon="chevron-back"></ion-back-button>
    <ion-title>{{'Map' | translate}}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content *ngIf="loaded">
  <!-- <ng-container *ngIf="!isIos">
    <ngx-apple-maps (onLoaded)="mapInit($event)" [options]="options" [settings]="settings">
      <ngx-apple-maps-annotation *ngFor="let location of locations" [latitude]="location.location[0]"
        [longitude]="location.location[1]" [options]="location.options">
      </ngx-apple-maps-annotation>
    </ngx-apple-maps>
  </ng-container> -->

  <ng-container>
    <!-- AGM MAP deprecated and changed with Angular/google-maps.-->

    <!-- <agm-map [zoom]="18" [latitude]="marker[0] || +dataServ.rData.lat_lng.split(',')[0]"
      [longitude]="marker[1] || +dataServ.rData.lat_lng.split(',')[1]">
      <agm-map-type-control></agm-map-type-control>
      <agm-marker *ngFor="let location of locations" (markerClick)="open(location.item)"
        [label]="location.item.name | caption" [latitude]="location.location[0]" [longitude]="location.location[1]">
      </agm-marker>

      <agm-marker *ngIf="marker[0]" [latitude]="marker[0]" [longitude]="marker[1]" [iconUrl]="icon"
        [markerDraggable]="false">
      </agm-marker>
    </agm-map> -->

    <google-map height="100%" width="100%" [zoom]="18" [center]="center">
        <map-marker *ngFor="let location of locations" [position]="{lat: +location.location[0], lng: +location.location[1]}" [label]="location.item.name | caption" (mapClick)="open(location.item)" [clickable]="true"></map-marker>
        <map-marker [position]="marker[0]"></map-marker>
    </google-map>
  </ng-container>

</ion-content>